import React, { Component } from 'react';
import { connect } from 'react-redux';
import PaymentCardLists from "../payment-card-lists/PaymentCardLists";
import AddCreditCardForm from "../AddCreditCardForm";
import AddCheckForm from "../AddCheckForm";
import { getPayerAccount, getSelectedPrimaryAccount, getSelectedSecondaryAccount } from "../../invoice/Selectors";
import { toast } from 'react-toastify';
import {
    addPaymentMethod,
    buildCCRequest, buildECRequest, cardFormToUpdateObject, checkFormToUpdateObject,
    getPaymentAccessToken,
    getPaymentResponse,
    getPaymetricResponse, preAuthCCPaymentMethod, updatePaymentMethod
} from "../../../requests/TokenRequests";
import { getPayerDetailsBuilder } from "../../../actions/InvoiceActions";
import { addSessionCard, addSessionCheck, updateSessionCard, updateSessionCheck } from "../../../reducers/PaymentReducer";
import PlayArrow from "../../../images/playarrow.png"
import PdfIcon from "../../../images/pdf.jpg"
import { getConfiguration} from "../../../requests/ConfigRequests";

export class ManagePaymentMethods extends Component {

    constructor(props) {
        super(props);
        this.state = {
            config: null,
            type: 'CC',
            editingPayment: null,
            isEditing: false,
        };
        this.addPaymentMethod = this.addPaymentMethod.bind(this);
        this.onTabChange = this.onTabChange.bind(this);
        this.isCC = this.isCC.bind(this);
        this.isEC = this.isEC.bind(this);
        this.onCardConfirmed = this.onCardConfirmed.bind(this);
        this.editPayment = this.editPayment.bind(this);
        this.saveCard = this.saveCard.bind(this);
        this.saveCheck = this.saveCheck.bind(this);
        this.processCard = this.processCard.bind(this);
        this.processCheck = this.processCheck.bind(this);
        this.deletePayment = this.deletePayment.bind(this);
        this.CCVideoClick = this.CCVideoClick.bind(this);
        this.CCPdfClick = this.CCPdfClick.bind(this);
        this.ECVideoClick = this.ECVideoClick.bind(this);
        this.ECPdfClick = this.ECPdfClick.bind(this);
        this.isValidURL = this.isValidURL.bind(this);
        
    }

    componentDidMount() {
        getConfiguration().then(
            config => this.setState({ config: config }
        ));
    }

    addPaymentMethod() {
        this.setState({ ...this.state, editingPayment: {}, isEditing: false });
    }

    isEditing() {
        return this.props.editingPayment !== null;
    }

    onTabChange(type) {
        this.setState({ ...this.state, type: type });
        // this.props.setEditingPayment(null);
    }

    isEC() {
        return this.state.type === 'EC';
    }

    isCC() {
        return this.state.type === 'CC';
    }

    async onCardConfirmed(payment_card) {
        this.setState({ ...this.state });
        // this.props.setEditingPayment(null);
    }

    editPayment(payment) {
        this.setState({
            editingPayment: payment,
            isEditing: true,
        });
    }

    async saveCard(card) {
        await this.processCard(card);
        getPayerDetailsBuilder(this.props.dispatch, this.props.primaryAccount, this.props.secondaryAccount, this.props.currentUser);
        this.setState({ editingPayment: null });
    }

    async saveCheck(card) {
        await this.processCheck(card);
        getPayerDetailsBuilder(this.props.dispatch, this.props.primaryAccount, this.props.secondaryAccount, this.props.currentUser);
        this.setState({ editingPayment: null });
    }


    async processCheck(card) {
        if (this.state.isEditing) {
            if (card.save_on_file) {
                let response = await updatePaymentMethod(
                    this.props.payerAccount.PrimaryAcct,
                    this.props.primaryAccount.CompanyCode,
                    checkFormToUpdateObject(card, this.state.editingPayment.payment_card_token),
                    card.make_default);
                return response;
            } else {
                this.props.dispatch(updateSessionCheck(checkFormToUpdateObject(card, this.state.editingPayment.payment_card_token), this.props.payerAccount.PrimaryAcct));
            }
        } else {
            const { access_token, merchant_guid, paymetric_xi_url } = await getPaymentAccessToken('EC');
            let body = buildECRequest(card, merchant_guid, access_token);

            try {
                await getPaymetricResponse(paymetric_xi_url, body);
            } catch (e) {
                toast.error(`Unable to save account details, please try again.`, { position: toast.POSITION.TOP_RIGHT });
                return;
            }

            let { paymentcard } = await getPaymentResponse(access_token);
            // We don't want to do this. pass payment card to props method
            if (card.save_on_file) {
                try {
                    await addPaymentMethod(this.props.payerAccount.PrimaryAcct, this.props.primaryAccount.CompanyCode, paymentcard, card.make_default);
                } catch (error) {
                    if (error.message_number === 74) {
                        let matches = error.message_string.match(/Payment card (CCINS) (.*) already exist, action ([0-9]*) not possible/);
                        toast.error(`${matches[2]} already exists.`, { position: toast.POSITION.TOP_RIGHT });
                    } else if (error.message_number === 76) {
                        let matches = error.message_string.match(/Payment card (CCINS) (.*) already assigned to account ([0-9]*)/);
                        toast.error(`${matches[2]} already assigned to account ${matches[3]}`, { position: toast.POSITION.TOP_RIGHT });
                    } else {
                        toast.error(error.message_string, { position: toast.POSITION.TOP_RIGHT });
                    }
                }
            } else {
                this.props.dispatch(addSessionCheck(paymentcard, this.props.payerAccount.PrimaryAcct));
            }
            return paymentcard;
        }
    }

    async processCard(card) {
        if (this.state.isEditing) {
            if (card.save_on_file) {
                let response = await updatePaymentMethod(
                    this.props.payerAccount.PrimaryAcct,
                    this.props.primaryAccount.CompanyCode,
                    cardFormToUpdateObject(card, this.state.editingPayment.payment_card_token),
                    card.make_default);
                return response;
            } else {
                this.props.dispatch(updateSessionCard(cardFormToUpdateObject(card, this.state.editingPayment.payment_card_token), this.props.payerAccount.PrimaryAcct));
            }
            return null;
        } else {
            const { access_token, merchant_guid, paymetric_xi_url } = await getPaymentAccessToken('CC');
            let body = buildCCRequest(card, merchant_guid, access_token);

            try {
                await getPaymetricResponse(paymetric_xi_url, body);
            } catch (e) {
                toast.error(`Unable to save account details, please try again.`, { position: toast.POSITION.TOP_RIGHT });
                return;
            }

            let { paymentcard } = await getPaymentResponse(access_token);
            // We don't want to do this. pass payment card to props method
            if (card.save_on_file) {
                try {
                    await addPaymentMethod(this.props.payerAccount.PrimaryAcct, this.props.primaryAccount.CompanyCode, paymentcard, card.make_default, card.card_validation_code);
                } catch (error) {
                    if (error.message_number === 74) {
                        let matches = error.message_string.match(/Payment card (CCINS) (.*) already exist, action ([0-9]*) not possible/);
                        toast.error(`${matches[2]} already exists.`, { position: toast.POSITION.TOP_RIGHT });
                    } else if (error.message_number === 76) {
                        let matches = error.message_string.match(/Payment card (CCINS) (.*) already assigned to account ([0-9]*)/);
                        toast.error(`${matches[2]} already assigned to account ${matches[3]}`, { position: toast.POSITION.TOP_RIGHT });
                    } else {
                        toast.error(error.message_string, { position: toast.POSITION.TOP_RIGHT });
                    }
                }
            } else {
                try {
                    //Add to session payment methods.
                    await preAuthCCPaymentMethod(this.props.payerAccount.PrimaryAcct, this.props.primaryAccount.CompanyCode, paymentcard, card.make_default, card.card_validation_code);
                    this.props.dispatch(addSessionCard(paymentcard, this.props.payerAccount.PrimaryAcct));
                } catch (error) {
                    toast.error(`Credit Card not approved.`, { position: toast.POSITION.TOP_RIGHT });
                }
            }
            return paymentcard;
        }
    }

    deletePayment(payment) {
        if (this.state.editingPayment && payment.payment_card_token === this.state.editingPayment.payment_card_token) {
            this.setState({ editingPayment: null });
        }
    }

    isValidURL(url) {
        const isAbsoluteUrl = /^([a-zA-Z][a-zA-Z\d+\-.]*):/.test(url);
        const normalizedUrl = isAbsoluteUrl ? url : `http://${url}`;
        return normalizedUrl;
    }
    
    CCVideoClick (){
        
        const url = this.state.config.CcvideoUrl; // Replace with your URL
        const normalizedUrl = this.isValidURL(url);
        window.open(normalizedUrl, '_blank');

    };

    CCPdfClick (){
        const url = this.state.config.CcpdfUrl; // Replace with your URL
        const normalizedUrl = this.isValidURL(url);
        window.open(normalizedUrl, '_blank');
    };

    ECVideoClick() {

        const url = this.state.config.EcvideoUrl; // Replace with your URL
        const normalizedUrl = this.isValidURL(url);
        window.open(normalizedUrl, '_blank');

    };

    ECPdfClick() {
        const url = this.state.config.EcpdfUrl; // Replace with your URL
        const normalizedUrl = this.isValidURL(url);
        window.open(normalizedUrl, '_blank');
    };


    render() {
        return <React.Fragment>
            <div className="row">
                <div className="col-md-6">
                    <PaymentCardLists onTabChange={this.onTabChange} onEdit={this.editPayment} onDelete={this.deletePayment} />
                    <div className={"text-center mt-3"}>
                        {this.isCC() && <button className={"btn btn-primary"} onClick={this.addPaymentMethod}>Add Card</button>}
                        {this.isEC() && <button className={"btn btn-primary"} onClick={this.addPaymentMethod}>Add eCheck</button>}
                    </div>
                </div>
                <div className="col-md-6">
                    {(this.state.editingPayment && this.isCC()) &&
                        <AddCreditCardForm payment={this.state.editingPayment} save={this.saveCard} isEditing={this.state.isEditing}
                            onCardConfirmed={this.onCardConfirmed}
                            alwaysSaveOnFile={this.props.alwaysSaveOnFile} />}
                    {(this.state.editingPayment && this.isEC()) &&
                        <AddCheckForm payment={this.state.editingPayment} isEditing={this.state.isEditing}
                            onCardConfirmed={this.onCardConfirmed} save={this.saveCheck}
                            alwaysSaveOnFile={this.props.alwaysSaveOnFile} />}
                </div>


            </div>
            <div className="row d-flex justify-content-center align-items-center" style={{ alignSelf: "center", marginTop:"20px" }}>

                <span
                    className="col-form-label col-form-label-sm text-primary nopadding">
                    <strong>Important Notice:</strong> Do not save credit card information if you have multiple accounts</span>


                {/*<div className="col-md-10">*/}
                {/*    <span*/}
                {/*        className="col-form-label col-form-label-sm text-secondary nopadding">*/}
                {/*        {"Do not save credit card information if you have multiple accounts"}</span>*/}
                {/*</div>*/}



            </div>
            <div className="row mt-3">
                <div className="col-md-6 mb-5">
                    <span style={{ textDecoration:"underline" }}
                        className="col-form-label col-form-label-sm text-primary nopadding d-flex justify-content-center align-items-center">
                        {"Click below for instructions to set up an E-Pay credit card: "}</span>
                    <div className="row d-flex justify-content-center align-items-center mt-2" >
                        <div className="col-md-2" style={{ cursor: "pointer" }}>
                            <img height="30px" onClick={this.CCVideoClick} width="30px" src={PlayArrow} alt="PlayArrow" />
                        </div>
                        <div className="col-md-2" style={{ cursor: "pointer" }}>
                            <img height="30px" onClick={this.CCPdfClick} width="30px" src={PdfIcon} alt="Pdf" />
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-5">
                    <span style={{ textDecoration: "underline" }}
                        className="col-form-label col-form-label-sm text-primary nopadding d-flex justify-content-center align-items-center">
                        {"Click below for instructions to set up an E-Pay eCheck: "}</span>
                    <div className="row d-flex justify-content-center align-items-center mt-2">
                        <div className="col-md-2" style={{ cursor: "pointer" }}>
                            <img height="30px" width="30px" src={PlayArrow} onClick={this.ECVideoClick}  alt="PlayArrow" />
                        </div>
                        <div className="col-md-2" style={{ cursor: "pointer" }}>
                            <img height="30px" width="30px" src={PdfIcon} onClick={this.ECPdfClick} alt="Pdf" />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    }

}

ManagePaymentMethods.defaultProps = {
    alwaysSaveOnFile: false,
};

export default connect((state, props) => {
    return {
        payerAccount: getPayerAccount(state, props),
        primaryAccount: getSelectedPrimaryAccount(state, props),
        secondaryAccount: getSelectedSecondaryAccount(state, props),
        currentUser: state.default.currentUser,
    }
})(ManagePaymentMethods)
